import { useFormContext } from "react-hook-form";
import { useEffect, useState } from "react";
import { ContractOrderRequest } from "forms/RequestOrderForm";

type SelectOptionNames = "shipFrom" | "mode" | "salesTerms" | "shipTo";

const selectOptionNames: (keyof ContractOrderRequest)[] = [
  "shipFrom",
  "mode",
  "salesTerms",
  "shipTo",
];

const useRequestOrderSelectOptionsStack = () => {
  const { setValue, watch } = useFormContext<ContractOrderRequest>();

  const [, setSelectedOptionsNameStack] = useState<string[]>([]);

  useEffect(() => {
    const subscription = watch((value, { name }) => {
      if (!name || !selectOptionNames.includes(name as SelectOptionNames)) {
        return;
      }
      setSelectedOptionsNameStack((prevSelectedNames) => {
        const optionIndex = prevSelectedNames.indexOf(name);
        let nextSelectedNames = prevSelectedNames;
        if (optionIndex >= 0) {
          // The option exists, so pop the "stack" and reset the fields that are popped off.
          const namesToReset = prevSelectedNames.slice(optionIndex + 1);
          namesToReset.forEach((name) =>
            setValue(name as keyof ContractOrderRequest, null)
          );
          nextSelectedNames = prevSelectedNames.slice(0, optionIndex);
        }
        // If the value for the given field is valid, add that name to/back to the stack
        return value[name as SelectOptionNames]
          ? [...nextSelectedNames, name]
          : nextSelectedNames;
      });
    });
    return () => subscription.unsubscribe();
  }, [setValue, watch]);
};

export default useRequestOrderSelectOptionsStack;
